import { create } from 'zustand'

const initialState = {
  isOpen: false,
  onKeep: null,
  onDiscard: null,
}

const useUnsavedChangesStore = create((set) => ({
  ...initialState,

  showUnsavedChangesDialog: (onKeep, onDiscard) => {
    set({ isOpen: true, onKeep, onDiscard })
  },

  hideUnsavedChangesDialog: () => {
    set(initialState)
  },

  handleKeep: () => {
    const { onKeep } = useUnsavedChangesStore.getState()
    if (onKeep) onKeep()
    set(initialState)
  },

  handleDiscard: () => {
    const { onDiscard } = useUnsavedChangesStore.getState()
    if (onDiscard) onDiscard()
    set(initialState)
  },
}))

export default useUnsavedChangesStore
